import { createSlice } from '@reduxjs/toolkit';
import extraReducers from './extraReducers';

const initialState = {
  list: [],
  lois: [],
  loading: false,
  loadingOrders: false,
  loadingApprovers: false,
  loadingLois: false,
  error: false,
  loiError: false,
};

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    restartOrders: (state) => {
      state.list = [];
      state.lois = [];
      state.loading = false;
      state.loadingOrders = false;
      state.loadingApprovers = false;
      state.loadingLois = false;
      state.error = false;
      state.loiError = false;
    },
  },
  extraReducers,
});

export const { restartOrders } = orderSlice.actions;
export {
  fetchOrders,
  deleteOrder,
  withdrawSentOrder,
  markAsSignOrder,
  sendApprovalReminder,
  assignOrderApprovers,
  withdrawOrderApproval,
  assignedOrderApprovers,
  rejectionAcknowledge,
  approveOrRejectOrder,
  approveOrRejectLoi,
  assignedApproversforDocument,
  assignedLoiApprovers,
  fetchOrderLogs,
  fetchLoiLogs,
  fetchProjectLois,
  assignLoiApprovers,
  withdrawLoiApproval,
  rejectionAcknowledgeLoi,
sendLoiApprovalReminder,
} from './extraReducers';
export default orderSlice.reducer;
